<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://quizgiri.xyz" target="_blank">Tetris</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} Einstech Studio.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://mazegeek.com">Mazegeek Inc</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
